<template>
  <div class="profile">
    <assets/>
    <auction/>
  </div>
</template>

<script>
import assets from "./assets.vue"
import auction from "./auction.vue"
export default {
  components: {
    assets,
    auction
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  watch: {}
};
</script>
<style scoped lang="scss">
.profile{
  margin:0 auto;
  max-width: 15.6rem;
}
</style>
